/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.23.0
 */

export enum ECollectiveProductFileds {
    ACCESS_TOKEN = 'accessToken',
    REFRESH_TOKEN = 'refreshToken',
    ACCOUNT_ID = 'accountId',
    LANDING_URL = 'landingUrl',
}
